import { useCallback, useMemo } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useSetOnboardingState } from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';
import { CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';

import { useIsEligibleRovoAnnouncement } from './useIsEligibleRovoAnnouncement';

const ANALYTICS_SOURCE = 'createWithRovoAnnouncementSplashModal';

export const useRovoAnnouncementSplashModal = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { setOnboardingState } = useSetOnboardingState();

	const { isEligible, hasSeenSplashModal, loading, error } = useIsEligibleRovoAnnouncement();

	const isModalVisible = useMemo(
		() => isEligible && !hasSeenSplashModal,
		[isEligible, hasSeenSplashModal],
	);

	const onModalShown = useCallback(
		(dismissSource: string) => {
			if (isModalVisible && !loading && !error) {
				setOnboardingState({
					key: CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH.HAS_SEEN_SPLASH_MODAL,
					value: 'true',
				});
				createAnalyticsEvent({
					type: 'sendUIEvent',
					data: {
						action: 'clicked',
						actionSubject: 'button',
						actionSubjectId: 'dismiss',
						attributes: {
							dismissSource,
						},
						source: ANALYTICS_SOURCE,
					},
				}).fire();
			}
		},
		[isModalVisible, createAnalyticsEvent, setOnboardingState, loading, error],
	);

	return {
		isModalVisible,
		onModalShown,
		loading,
		error,
	};
};
